import { useMount } from '@p2p/shared/hooks';
import cn from 'classnames';

import { usePaymentTemplate } from '../../templates';
import styles from './MainContainer.module.scss';
import { MainContainerProps } from './MainContainer.types';

export const MainContainer = ({
  children,
  className,
  marginTop = 'default',
  maxWidth = '',
}: MainContainerProps) => {
  const { setTemplateGap } = usePaymentTemplate();
  const maxWidthStyle = maxWidth ? { maxWidth } : {};

  useMount(() => {
    setTemplateGap(marginTop);

    return () => {
      setTemplateGap('default');
    };
  });

  return (
    <div className={cn(styles.container, className)} style={maxWidthStyle}>
      {children}
    </div>
  );
};
